import React, { Component } from "react";
import { Button } from "reactstrap";
import SweetAlert from 'react-bootstrap-sweetalert';
import Loader from "react-loaders";
import { AiOutlineDownload } from "react-icons/ai";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import SOSTOSLogo from "../../assets/images/svg/Sostoslogo.svg";
import SubscriptionChange from "./subscriptionChange";
import axiosInstance from "../configuration/Request";

export default class Billing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cancelPopupVerify: false,
      activePlanDetails: {},
      clickedUpdatePlan: false,
      subscriptionList: [],
      paymentSuccessPopup: false,
      paymentCanceledPopup: false,
      loader: false,
    };
  }

  componentDidMount() {
    // Fetch latest subscription details from API
    this.fetchActivePlan();

    // Handle payment status from URL query parameters
    const searchParams = new URLSearchParams(window.location.search);
    const paymentStatus = searchParams.get('payment_status');

    if (paymentStatus === 'success') {
      this.setState({ paymentSuccessPopup: true });
      this.cleanupUrl();
    } else if (paymentStatus === 'canceled') {
      this.setState({ paymentCanceledPopup: true });
      this.cleanupUrl();
    }
  }

  fetchActivePlan = () => {
    this.setState({ loader: true });

    axiosInstance
      .get(`${process.env.REACT_APP_BASE_URL}api/user-subscription-details?filters[userid][$eq]=${this.props?.loginDetails?.user?.id}&active=true`)
      .then((res) => {
        const subscriptionData = res?.data?.data || [];

        const activeData = subscriptionData.filter(item => item.attributes?.active === true);

        // Update Redux store with only active subscriptions
        if (this.props?.setloginSubscriptionDetail) {
          this.props.setloginSubscriptionDetail(activeData);
        }

        // Find the active plan
        const highestIdObject = activeData.find(item => item.attributes?.active === true) || { id: 0 };

        // Sort all subscription records by ID descending for order history
        const sortedList = subscriptionData?.length > 0
          ? subscriptionData.slice().sort((a, b) => b?.id - a?.id)
          : [];

        this.setState({
          activePlanDetails: highestIdObject,
          subscriptionList: sortedList,
          loader: false
        });
      })
      .catch((err) => {
        console.error("Error fetching subscription details:", err);
        this.setState({ loader: false });
      });
  }

  cleanupUrl = () => {
    const url = new URL(window.location.href);
    url.search = '';
    window.history.replaceState({}, document.title, url.toString());
  }

  onClickCancel = () => {
    this.setState({ cancelPopupVerify: true });
  }
  changeSubcription = () => {
    const isBronzeUser = this.state.activePlanDetails?.attributes?.plan?.toUpperCase() === 'BRONZE';

    // If Bronze user, redirect to subscription page with back button support
    if (isBronzeUser) {
      this.props.history.push('/auth/subscription?fromBilling=true');
      return;
    }

    // For non-Bronze users, proceed with portal session
    this.setState({ loader: true });

    axiosInstance
      .post(`${process.env.REACT_APP_BASE_URL}api/payment/portal-session`)
      .then((res) => {
        console.log("res : ", res)
        console.log("res : ", res.data.url)
        this.setState({ loader: false });
        window.location.href = res?.data?.url;
      })
      .catch((err) => {
        console.error("Error fetching subscription details:", err);
        this.setState({ loader: false });
      });
  }

  fetchEndDate = (activePlanDetails) => {
    const utcDate = new Date(activePlanDetails?.attributes?.expiry);
    return new Date(utcDate).toLocaleDateString('en-GB');

  }
  fetchDate = (activePlanDetails) => {
    const utcDate = new Date(activePlanDetails?.attributes?.subscription_date);
    return new Date(utcDate).toLocaleDateString('en-GB');
  }

  getAmount = (activePlanDetails) => {
    if (activePlanDetails?.attributes?.currency?.toUpperCase() === 'USD') {
      return `$${activePlanDetails?.attributes?.amount}/${activePlanDetails?.attributes?.frequency?.toUpperCase() === 'YEARLY' ? 'year' : "month"}`
    } else {
      return activePlanDetails?.attributes?.amount
    }
  };


  generatePDF = (item) => {
    this.setState({ loader: true });

    const invoiceContent = `
          <div style="font-family: Arial, sans-serif; width: 210mm; height: 297mm; padding: 20mm; box-sizing: border-box; border: 1px solid #ccc;">
          <div style="text-align: left;">
          <img src=${SOSTOSLogo} alt="" style="width: 120px"/>
          </div>
          <div style="text-align: left; margin-bottom: 20mm;">
            <h1 style="margin: 0;">SOSTOS</h1>
          </div>
            <div style="margin-bottom: 20mm;">
              <h2 style="margin: 0;">Invoice</h2>
              <p style="margin: 5mm 0 0 0;"><strong>Transaction id:</strong> ${item?.attributes?.transaction_id}</p>
            </div>
            <div style="margin-bottom: 20mm;">
              <p style="margin: 0;"><strong>${this.props?.loginDetails?.user?.username}</strong></p>
              <p style="margin: 5mm 0 0 0;">${this.props?.loginDetails?.user?.email}</p>
            </div>
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 20mm;">
              <thead>
                <tr>
                  <th style="border-bottom: 1px solid #ccc; text-align: left; padding-bottom: 5mm;">Item</th>
                  <th style="border-bottom: 1px solid #ccc; text-align: left; padding-bottom: 5mm;">Date</th>
                  <th style="border-bottom: 1px solid #ccc; text-align: left; padding-bottom: 5mm;">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="padding-top: 5mm;">${item?.attributes?.plan} ${item?.attributes?.frequency?.toUpperCase() === 'YEARLY' ? 'Annual' : "Monthly"}</td>
                  <td style="padding-top: 5mm;">${this.fetchDate(item)}</td>
                  <td style="padding-top: 5mm;">$${item?.attributes?.amount}</td>
                </tr>
              </tbody>
            </table>
            <div style="margin-top: 20mm;">
              <p style="margin: 0;">Questions about your order contact info@sostosinc.com</p>
            </div>
          </div>
        `;

    const hiddenDiv = document.createElement('div');
    hiddenDiv.innerHTML = invoiceContent;
    hiddenDiv.style.position = 'absolute';
    hiddenDiv.style.left = '-9999px';
    document.body.appendChild(hiddenDiv);

    html2canvas(hiddenDiv).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      pdf.addImage(imgData, 'PNG', 0, 0);
      pdf.save("invoice.pdf");
      document.body.removeChild(hiddenDiv); // Clean up the hidden div
    });
    this.setState({ loader: false });
  }

  backClicked = () => {
    this.setState({ clickedUpdatePlan: false })
  }

  onCancelSubscriptionOkClick = () => {
    var date = new Date();

    axiosInstance.put(process.env.REACT_APP_BASE_URL + `api/user-subscription-details/${this.state?.activePlanDetails?.id}`,
      {
        "data": {
          "subscription_cancel_date": date?.toISOString() ?? '',
          "is_cancelled": true
        }
      })
      .then(response => {
        // Refresh subscription details after cancellation
        this.fetchActivePlan();
        this.setState({ cancelPopupVerify: false });
      })
      .catch(error => {
        console.log(error, 'error')
      });
  };



  render() {
    const { activePlanDetails, clickedUpdatePlan, subscriptionList } = this.state;
    const planType = activePlanDetails?.attributes?.frequency?.toUpperCase() === 'YEARLY' ? 'Annual' : 'Monthly';
    const planStatus = activePlanDetails?.attributes?.active ? 'Active' : 'InActive';
    const planName = `${activePlanDetails?.attributes?.plan} ${planType} Plan: ${planStatus}`;

    return (
      <>
        {!clickedUpdatePlan ? (
          <div className="billing-container">
            <div className="billing-main-header">
              <h2>Billing</h2>
              <p>Manage your current subscription and review your order history.</p>
            </div>

            <div className="current-plan-card">
              <div className="plan-info">
                <span className="plan-label">Current Plan</span>
                <div className="plan-title">{planName}</div>
                {!activePlanDetails?.attributes?.is_cancelled && (
                  <p className="plan-subtext">Next payment on {this.fetchEndDate(activePlanDetails)} for {this.getAmount(activePlanDetails)}</p>
                )}
                {activePlanDetails?.attributes?.is_cancelled && (
                  <p className="plan-subtext">You have cancelled your current subscription plan. You can use the plan benefits till {this.fetchEndDate(activePlanDetails)}.</p>
                )}
              </div>
              <div className="plan-actions">
                {/* {activePlanDetails?.attributes?.plan?.toUpperCase() !== 'BRONZE' && !activePlanDetails?.attributes?.is_cancelled && (
                  <button className="cancel-btn" onClick={this.onClickCancel}>
                    Cancel Subscription
                  </button>
                )} */}
                <button className="change-btn" onClick={this.changeSubcription}>
                  Change Subscription
                </button>
              </div>
            </div>

            <div className="order-history-section">
              <div className="section-title">Order History</div>
              <div className="order-table-container">
                <table className="order-table">
                  <thead>
                    <tr>
                      <th>Subscription Start Date</th>
                      <th>Subscription End Date</th>
                      <th>Type</th>
                      <th>Invoice</th>
                    </tr>
                  </thead>
                  <tbody>
                    {subscriptionList?.length > 0 ? (
                      subscriptionList.map((item, index) => (
                        <tr key={index}>
                          <td>{this.fetchDate(item)}</td>
                          <td>{this.fetchEndDate(item)}</td>
                          <td>{`${item?.attributes?.plan} ${item?.attributes?.frequency?.toUpperCase() === 'YEARLY' ? 'Annual' : 'Monthly'}`}</td>
                          <td>
                            <div className="pdf-link" onClick={() => this.generatePDF(item)} role="button">
                              PDF <AiOutlineDownload size={16} />
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" style={{ textAlign: 'center', color: '#6c757d' }}>No order history found.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : (
          <SubscriptionChange backClicked={this.backClicked} activePlanDetails={activePlanDetails} />
        )}
        <SweetAlert title="Wish to cancel the subscription?" show={this.state.cancelPopupVerify}
          confirmBtnText='Cancel Subscription'
          onConfirm={this.onCancelSubscriptionOkClick}>
          Your subscription will end on {this.fetchEndDate(activePlanDetails)}. You will still be able to enjoy the benefits until the end of the current subscription period.</SweetAlert>

        <SweetAlert
          title="Payment Successful!"
          show={this.state.paymentSuccessPopup}
          confirmBtnText='OK'
          onConfirm={() => this.setState({ paymentSuccessPopup: false })}>
          Your payment has been processed successfully! Your subscription has been updated.
        </SweetAlert>

        <SweetAlert
          title="Payment Canceled"
          show={this.state.paymentCanceledPopup}
          confirmBtnText='OK'
          onConfirm={() => this.setState({ paymentCanceledPopup: false })}>
          Your payment was canceled. No charges have been made to your account.
        </SweetAlert>

        {this.state.loader &&
          <div className="backdrop">
            <div className="loader">
              <Loader type="ball-pulse-rise" />
            </div>
          </div>
        }

      </>
    );
  }
}